import type { PlanOptionsResult } from '#shared/billing/planScreen'

/**
 * Whether a PAID checkout can open for the signed-in user (MAR-1474): billing's `checkoutAvailable` as
 * `/api/billing/plans` carries it, read once per page load and shared (Nuxt `useState`). It is billing's provider
 * registry, never a flag of web's: while no payment provider is configured (v1.0 on staging and prod) it is false,
 * and every entry point that leads to the plan checkout — the free chat's upgrade CTAs, the attachment teaser —
 * hides itself.
 *
 * FAILS CLOSED: false until billing has answered, and false if it could not, so a CTA never leads to a checkout
 * billing would refuse. The plan step reads the same endpoint itself, with its prices.
 */
export function useCheckoutAvailability() {
  const state = useState<boolean | null>('marcus:checkout-available', () => null)
  if (state.value === null && import.meta.client) {
    // Claimed before the request, so two components mounting together ask once.
    state.value = false
    const { apiFetch } = useApi()
    apiFetch<PlanOptionsResult>('/api/billing/plans')
      .then((options) => { state.value = options.checkoutAvailable === true })
      .catch(() => { state.value = false })
  }
  return { checkoutAvailable: computed(() => state.value === true) }
}
